import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { templateToTitle } from '@apps/card/Card.utils';
import { FoilBadge } from '../../FoilBadge';
import { useCardsRouterContext } from '@apps/card/Card.routes';
import { StationeryTemplateCategoryEnum, useMatchingFoilTemplateDataQuery } from '@graphql/generated';
import { useTranslation } from '@shared/core';

interface MatchingFoilTemplateProps {
  category: StationeryTemplateCategoryEnum;
  themeId: string;
}

export const MatchingFoilTemplate = ({ themeId, category }: MatchingFoilTemplateProps) => {
  const { t } = useTranslation('stationery');
  const tMatchingFoilTemplate = t('pdpModal', 'customizationPane', 'matchingFoilTemplate');
  const { goToProductDetailsPage } = useCardsRouterContext();

  const { data } = useMatchingFoilTemplateDataQuery({
    variables: {
      themeId: `${themeId}_foil`,
      category
    },
    batchMode: 'fast'
  });

  const foilTemplate = data?.stationeryTemplatesByThemeId?.[0];

  if (!foilTemplate || !foilTemplate.thumbnailUrl) {
    return null;
  }

  const handleClick = () => {
    goToProductDetailsPage('wedding', category, foilTemplate.themeId, foilTemplate.id);
  };

  return (
    <Flex flexDirection="column" gap={5} marginTop={10}>
      <TextV2 typographyVariant="body2" fontWeight={600}>
        {tMatchingFoilTemplate.title()}
      </TextV2>
      <Flex
        onClick={handleClick}
        role="button"
        cursor="pointer"
        aspectRatio="1/1"
        overflow="hidden"
        width="100%"
        justifyContent="center"
        alignItems="center"
        backgroundColor="mono1"
        padding={8}
        position="relative"
        flexDirection="column"
      >
        <Box position="absolute" top={7} left={5}>
          <FoilBadge />
        </Box>
        <Box as="img" maxWidth="100%" maxHeight="100%" objectFit="contain" src={foilTemplate.thumbnailUrl} alt="Foil template" boxShadow="0px 4px 4px 0px rgba(0, 0, 0, 0.25)" />
      </Flex>
      <TextV2 typographyVariant="body2" fontWeight={600} width="100%" textAlign="center">
        {templateToTitle(foilTemplate)}
      </TextV2>
    </Flex>
  );
};
